import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const TYPE_STYLE = {
  order: "bg-blue-50 text-blue-800",
  birthday: "bg-pink-50 text-pink-800",
  anniversary: "bg-purple-50 text-purple-800",
  partner_dob: "bg-amber-50 text-amber-800",
  partner_anniversary: "bg-emerald-50 text-emerald-800",
};

export default function CalendarPage() {
  const [byDay, setByDay] = useState({});
  const [cursor, setCursor] = useState(new Date());

  useEffect(() => { api.get("/calendar").then(r => setByDay(r.data)).catch(() => {}); }, []);

  const year = cursor.getFullYear(), month = cursor.getMonth();
  const firstDay = new Date(year, month, 1);
  const startWeekday = firstDay.getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const fmt = (d) => `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

  return (
    <div className="p-3 sm:p-6 lg:p-10 max-w-full">
      <header className="flex justify-between items-end mb-6">
        <div>
          <p className="label-eyebrow">All important dates</p>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{MONTHS[month]} {year}</h1>
          <p className="text-gray-500 mt-1 text-sm">Orders · Client birthdays/anniversaries · Partner DOB & special anniversaries</p>
        </div>
        <div className="flex gap-2">
          <button className="btn-brand" onClick={() => setCursor(new Date(year, month - 1, 1))} data-testid="calendar-prev">←</button>
          <button className="btn-brand" onClick={() => setCursor(new Date(year, month + 1, 1))} data-testid="calendar-next">→</button>
        </div>
      </header>
      <Card className="p-4">
        <div className="grid grid-cols-7 text-xs uppercase tracking-wide text-gray-500 mb-2">
          {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => <div key={d} className="p-2">{d}</div>)}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {cells.map((d, i) => {
            const key = d ? fmt(d) : null;
            const events = key ? (byDay[key] || []) : [];
            return (
              <div key={i} className={`min-h-[110px] p-2 border border-[var(--border)] rounded ${d ? "bg-white" : "bg-transparent border-transparent"}`} data-testid={d ? `calendar-day-${d}` : undefined}>
                {d && <div className="text-sm font-semibold text-gray-700">{d}</div>}
                <div className="mt-1 space-y-1">
                  {events.slice(0, 4).map((e, j) => (
                    <div key={j} className={`text-xs rounded px-1.5 py-0.5 truncate ${TYPE_STYLE[e.type] || "bg-gray-50 text-gray-700"}`}>{e.title}</div>
                  ))}
                  {events.length > 4 && <div className="text-xs text-gray-500">+{events.length - 4} more</div>}
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
